import { FunctionComponent } from 'react'
import styles from './datePicker.module.scss'
import globalStyles from '@/styles/components.module.scss'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { parse } from 'date-fns/parse'
import { format } from 'date-fns'
import { PickerValue } from '@mui/x-date-pickers/internals'

interface DatePickerComponentProps {
    label?: string
    value: string
    setValue: (date: string) => void
    disabled?: boolean
    readOnly?: boolean
    disablePast?: boolean
    className?: string
    parent?: boolean
    allowEmpty?: boolean
    minDate?: string
    maxDate?: string
    onChange?: (date: string) => void
    error?: boolean
}

const DatePickerComponent: FunctionComponent<DatePickerComponentProps> = ({
    label,
    value,
    setValue,
    disabled = false,
    readOnly = false,
    disablePast = true,
    className,
    parent = false,
    allowEmpty = false,
    minDate,
    maxDate,
    onChange,
    error = false
}: DatePickerComponentProps) => {
    function changeDate(date: PickerValue): void {
        if (date) {
            const formatted: string = format(date, 'dd-MM-yyyy')
            setValue(formatted)
            if (onChange) {
                onChange(formatted)
            }
        }
    }

    return (
        <DatePicker
            label={label}
            views={['year', 'month', 'day']}
            value={!allowEmpty || value !== '' ? parse(value, 'dd-MM-yyyy', new Date()) : undefined}
            onChange={changeDate}
            disabled={disabled}
            readOnly={readOnly}
            minDate={minDate && minDate !== '' ? parse(minDate, 'dd-MM-yyyy', new Date()) : undefined}
            maxDate={maxDate && maxDate !== '' ? parse(maxDate, 'dd-MM-yyyy', new Date()) : undefined}
            disablePast={disablePast}
            className={`${className} ${parent ? styles.Parent : styles.Daycare} ${error ? globalStyles.FieldInError : ''}`}
        />
    )
}

export default DatePickerComponent
